import Head from 'next/head'
import styles from '../../styles/index.module.css'
import Script from 'next/script'

export default function Home() {

  return (
    <>
      <Head>
        <title>Refund Policy on Service for Consumer Clients | StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="The terms on refund policy only applies to consumer client who have taken a service directly through StringsSG and have made the payment to StringsSG invoice and have a receipt for it."/>
        <meta name="keywords" content="We help you in HDB or Condo rental and purchase, health Investment and Insurance plan, food catering,
	         domestic helper, handyman services, aircon servicing, beauty and massage, interior designing, fitness trainer, 
	         wedding, birthday and other event planning"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/terms/refund-policy-on-service-for-consumer-client" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Terms of Packaged Service for Service Provider | StringsSG`}/>
        <meta property="og:description" content="The terms on refund policy only applies to consumer client who have taken a service directly through StringsSG and have made the payment to StringsSG invoice and have a receipt for it." />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/terms/refund-policy-on-service-for-consumer-client"/>
        <meta name="twitter:title" content={`Terms of Packaged Service for Service Provider | StringsSG`}/> 
        <meta name="twitter:description" content="The terms on refund policy only applies to consumer client who have taken a service directly through StringsSG and have made the payment to StringsSG invoice and have a receipt for it."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/terms/refund-policy-on-service-for-consumer-client"/>
        </Head>
            <div className="max-w-4xl mx-auto py-4"> 
                <div id="refund-policy" className='text-gray-500 p-4 space-y-6 py-8 leading-7 text-sm'>
                    <h1 className='text-xl uppercase'>Refund Policy on Service for Consumer Clients</h1>
                    <div className='space-y-2'>
                        <div className='font-bold'>Who is a consumer client?</div>
                        <p>
                            You are a consumer client for StringsSG, if you have registered an account with us and have availed any professional service like handyman service, 
                            air conditioner servicing, personal training, domestic helper etc.
                        </p>
                        <p>
                            The terms on refund policy only applies to consumer client who have taken a service directly through StringsSG and have made the payment to StringsSG 
                            invoice and have a receipt for it. Any dealing directly with any service provider listed on StringsSG platform is not eligible for refund.
                        </p>
                        <p>
                            These Terms of Service govern the refund policy for StringsSG (referred to as &quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) with respect to payments made for our services by a Request. 
                            By using our app, website and our services, you agree to comply with the following refund policy:
                        </p>
                    </div>
                    <h2 className='text-lg font-bold'>Adhoc Services</h2>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>1. No Refund if Service is Provided:</h3>
                        <p>
                            Once we have successfully provided the requested service, no refunds will be issued.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>2. No Refund if the Request is Cancelled on the Date of Service:</h3>
                        <p>
                            If you cancel your request on the same date as the scheduled service, no refunds will be provided.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>3. 50% Refund if Request is cancelled after 24 hours of the request open time and 24 hours before the Service Date/Time:</h3>
                        <p>
                            If you cancel your request after 24 hours of the request open time and 24 hours before the service Date/Time, you are eligible for a 50% refund. The refund will be processed using the original payment method.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>4. 100% Refund if Request is Cancelled within 24 Hours of Open and the Service Date/Time is Greater than 48 Hours:</h3>
                        <p>
                            If you cancel your request within 24 hours of opening it, and the requested service date/time is scheduled to occur more than 48 hours in the future, you are eligible for a 100% refund. The refund will be processed using the original payment method.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>5. 100% Refund if Request is Cancelled within 24 Hours of Open and the Service Date/Time is Greater than 48 Hours:</h3>
                        <p>
                            If you cancel your request within 24 hours of opening it, and the requested service date/time is scheduled to occur more than 48 hours in the future, you are eligible for a 100% refund. The refund will be processed using the original payment method.
                        </p>
                    </div>
                    <h2 className='text-lg font-bold'>Packaged/Recurring Services</h2>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>1. No Refund if Service is Provided:</h3>
                        <p>
                            Once we have successfully provided the requested service, no refunds will be issued.
                        </p>
                    </div>                    
                    <div className='space-y-2'>
                        <h3 className='font-bold'>2. 100% Refund if Request is Cancelled within 24 Hours of Open and the Service Date/Time is Greater than 48 Hours:</h3>
                        <p>
                            If you cancel your request within 24 hours of opening it, and the first occurrence of the requested service date/time is scheduled to occur more than 48 hours in the future, you are eligible for a 100% refund. The refund will be processed using the original payment method.
                        </p>
                    </div>
                    <div className='space-y-2'>
                        <h3 className='font-bold'>3. Charges on cancellation of subsequent services (does not apply to Helper service or Aircon service):</h3>
                        <p>
                            Notice of cancellation of subsequent services must be given to StringsSG 48 hours prior to the next service, for the next service to be included in the cancelation.
                            The amount charged for the subsequent services will be refunded after a deduction of $30 as processing fee for the cancellation.
                        </p>
                    </div>
                    <div>
                        <h3 className='font-bold'>Changes to Refund Policy:</h3>
                        <p>
                            We may update or modify this refund policy at any time without prior notice. It is your responsibility to review the refund policy periodically to stay informed about any changes.
                            By using our website and services, you agree to abide by this refund policy. If you do not agree with these terms, please refrain from using our website and services.
                            If you have any questions or concerns regarding our refund policy, please contact our customer support team at support@stringssg.com.
                        </p>
                    </div>
                </div>
            </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
